import {SkuPricingWidget} from './widgets/sku-pricing/sku-pricing.widget';
import {PurchasesWidget,InboundAttentionWidget,ArrivingWidget} from './widgets/work-queue/work-queue.widget';
import { Injectable } from '@angular/core';
import { DashboardRegistry } from './dashboard-registry';
import { FinalizePurchaseOrdersWidget, FINALIZE_POS_RULES } from './widgets/finalize-purchase-orders/finalize-purchase-orders.widget';
import { InventoryTrackingWidget, INVENTORY_TRACKING_RULES } from './widgets/inventory-tracking/inventory-tracking.widget';
import { OrderQueueWidget, ORDER_QUEUE_RULES } from './widgets/order-queue/order-queue.widget';
import { SupplierRequestsWidget, SUPPLIER_REQUEST_RULES } from './widgets/supplier-requests/supplier-requests.widget'


@Injectable({ providedIn: 'root' })

export class DashboardWidgetsService
{
  widgets = [
    {component:SkuPricingWidget,title:'SKU Price Updates',key:'sku-price-updates',rules:{minCols:4,maxCols:15,minRows:4,maxRows:16}},
    {component:ArrivingWidget,title:'Arriving This Week',key:'arriving-week',rules:{minCols:4,maxCols:15,minRows:4,maxRows:12}},
    {component:PurchasesWidget,title:'Recent Purchases',key:'recent-purchases',rules:{minCols:4,maxCols:15,minRows:4,maxRows:12}},
    {component:InboundAttentionWidget,title:'Inbound Attention',key:'inbound-attention',rules:{minCols:4,maxCols:15,minRows:4,maxRows:12}},
    { component: FinalizePurchaseOrdersWidget, title: 'Finalize Purchase Orders', key: 'finalize-pos', rules: FINALIZE_POS_RULES },
    { component: InventoryTrackingWidget, title: 'Inventory Tracking', key: 'inventory-tracking', rules: INVENTORY_TRACKING_RULES },
    { component: OrderQueueWidget, title: 'Order Queue', key: 'order-queue', rules: ORDER_QUEUE_RULES },
    { component: SupplierRequestsWidget, title: 'Supplier Requests', key: 'supplier_request', rules: SUPPLIER_REQUEST_RULES },
  ]
  constructor(private reg: DashboardRegistry ) { }
  GetAllWidgets(): any[]{
    let wid : any[] = [];
    this.widgets.forEach((w: any) => {
      this.reg.register(w.key, w.component, w.title, w.rules);
      if (!['finalize-pos','inventory-tracking','order-queue'].includes(w.key)) wid.push({ key: w.key, title: w.title });
    });
    return wid;
  }
}
